import isNil from 'lodash/isNil';

function formatRevisionText(revision) {
  if (isNil(revision) || revision === '') {
    return '-';
  }

  return `Revision ${revision}`;
}

export default formatRevisionText;
